import { Model as BaseModel } from 'javel'
let axiosInstance = null

function httpClient () {
	if (!axiosInstance) {
		const mod = require('@/plugins/axios')
		axiosInstance = mod.default || mod
	}
	return axiosInstance
}

export default class Model extends BaseModel {
	baseUrl () {
		return '/api/'
	}

	makeRequest ({ method, url, data, query, onUploadProgress, responseType, headers, signal, timeout, skipAuthRefresh }) {
		return httpClient()({
			method,
			url,
			data,
			params: query,
			onUploadProgress,
			responseType,
			headers,
			signal,
			timeout,
			skipAuthRefresh
		})
	}
}
